import {
  COMMERCIAL,
  ENGINEERING_NETWORKS,
  FURNISHING_SUPERVISOR,
  HEAD_EN,
  HEAD_OVP,
  MKD,
  OBSERVER,
  PARTNER,
  PLANNER,
  PRIME_CONTRACTOR,
  HOUSING_CONTRACTOR,
  ROUTES,
  SUPERVISOR,
  USK_PRE_ACCEPTANCE,
  UNSET,
  ACCOUNTING_TYPES,
} from 'consts';

import { ROLES } from 'types';

export const getInitialRoute = (role: ROLES, accountingType: ACCOUNTING_TYPES | null) => {
  switch (role) {
    // TODO подумать над подролями или как все проверки на подтип ГП вынести в одно место
    case PRIME_CONTRACTOR:
      if (Array.isArray(accountingType) && accountingType.includes(MKD)) {
        return ROUTES.APARTMENT_STATUS.ROOT;
      }
      return ROUTES.PLACEMENTS_STATUS.ROOT;
    case HOUSING_CONTRACTOR:
      return ROUTES.PLACEMENTS_STATUS.ROOT;
    case USK_PRE_ACCEPTANCE:
    case COMMERCIAL:
    case HEAD_OVP:
    case FURNISHING_SUPERVISOR:
    case SUPERVISOR:
    case OBSERVER:
      return ROUTES.APARTMENT_STATUS.ROOT;
    case PARTNER:
      return ROUTES.APARTMENT_LIST.ROOT;
    case HEAD_EN:
    case ENGINEERING_NETWORKS:
      return ROUTES.ENGINEERING.ROOT;
    case PLANNER:
      return ROUTES.UPLOADING_PLAN.APARTMENTS;
    case UNSET:
      return ROUTES.SYSTEM.NOT_ROLE;
    default:
      return ROUTES.SYSTEM.ROOT;
  }
};
